// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2-yHf","selected":"Chip_selected__8zQnt"};